import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import { connect } from "react-redux";
import SweetAlert from "sweetalert-react";
import * as Utils from "../../utils/utils";
import * as Swal from "../../utils/swalHelpers";
import * as LocalStorage from "../../utils/localStorageHelper";
import WineIcon from "../../assets/images/wine.svg";
import BeerIcon from "../../assets/images/beer.svg";
import ChevronIcon from "../../assets/images/icons/right-thin-chevron.svg";
import LiquorIcon from "../../assets/images/liquor.svg";
import MainSlider from "../../components/home/slider/MainSlider";
import SpecialOffers from "../../components/home/special-offers/SpecialOffers";
import ProductCard from "../../components/commons/cards/ProductCard";
import FeaturedList from "../../components/commons/lists/FeaturedList";
import * as ProductsActions from "../../actions/productsActions";
import * as UserActions from "../../actions/userActions";
import Loader from "../../components/commons/loader/loader";
import withSizes from "react-sizes";
import menuDepKeys from "../../utils/menuHelper";
import QueryString from "query-string";

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlert: false,
      swalParams: {
        title: ""
      },
      openDepartmentMenu: false,
      currentDepartment: undefined
    };

    this.doAgeValidation = this.doAgeValidation.bind(this);
    this.renderProducts = this.renderProducts.bind(this);
    this.exploreProduct = this.exploreProduct.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.checkAvailiblityAlert = this.checkAvailiblityAlert.bind(this);
    this.handleError = this.handleError.bind(this);
    this.onSelectFeaturedProduct = this.onSelectFeaturedProduct.bind(this);
    this._onCancel = this._onCancel.bind(this);
    this.handleDepartmentClick = this.handleDepartmentClick.bind(this);
  }
  componentDidMount() {
    this.doAgeValidation();
    let params = {
      limit: 3,
      skip: 0,
      from: "home"
    };
    const callback = response => {
      if (response.status) {
        // id is required
        const impressions = response.data.map(p => ({
          id: p._id,
          name: p.Description,
          ...p
        }));
        window.dataLayer.push({ event: "home", ecommerce: { impressions } });
      } else {
        this.handleError(response);
      }
    };

    this.props.dispatch(
      ProductsActions.getNewArrivalProducts(params, callback)
    );
    this.props.dispatch(ProductsActions.getSpecialProducts(params, callback));
    this.props.dispatch(
      ProductsActions.fetchFeaturedProducts("WINES", callback)
    );
    this.props.dispatch(
      ProductsActions.fetchFeaturedProducts("BEER", callback)
    );
    this.props.dispatch(
      ProductsActions.fetchFeaturedProducts("LIQUOR", callback)
    );
    this.props.dispatch(UserActions.promoImage());
    
  }
  

  componentWillReceiveProps(newProps, oldProps) {
    console.log(newProps, oldProps);
    if (newProps.location) {
      const location = newProps.location;
      const { department } = QueryString.parse(location.search);
      console.log(department);
      if (department) {
        this.setState({
          openDepartmentMenu: true,
          currentDepartment: decodeURIComponent(department)
        });
      } else {
        this.setState({
          openDepartmentMenu: false,
          currentDepartment: undefined
        });
      }
    }
  }

  exploreProduct(product) {
    console.log("PRODUCT_SELECTED_ID: ", product._id);
    this.props.history.push(`/products/${product._id}`);
  }
  
  renderProducts(type) {
    
    let category;
    if (type == "newArrivals") {
      category = Utils.toJS(this.props.newArrivals);
    } else {
      category = Utils.toJS(this.props.specials);
    }
    if (category) {
      return (
        <div className="row">
          {category.map(product => {
            return (
              <div
                className="col-md-4 col-sm-4 product-card-container"
                key={product._id}
              >
                <ProductCard
                  data={product}
                  onSelectProduct={() => this.exploreProduct(product)}
                  onAddToCart={() => this.addToCart(product)}
                  checkAvailiblityAlert={() => this.checkAvailiblityAlert()}
                  noOutOfStock={true}
                />
              </div>
            );
          })}
        </div>
      );
    } else {
      return "Loading";
    }
  }

  handleDepartmentClick(department) {
    this.props.history.push(
      `/?department=${encodeURIComponent(department.dep)}`
    );
    window.scrollTo(0, 0);
  }

  renderMobileDepartments() {
    let { departments, promoImage } = this.props;
    departments = departments.sort((a, b) => {
      return a.priority > b.priority;
    });
    console.log(departments);
    return (
      <div className="main-nav-mobile">
        <div className="d-flex text-center p-3 border-bottom-gray text-uppercase"><div className="col"><Link to="/products/newarrivals">New Arrivals</Link></div><div className="col border-left-gray"><Link to="/products/specials">Specials</Link></div></div>
        <ul className="list">
          {departments.map(department => {
            return menuDepKeys[department.dep] ? (
              <li key={department.dep}>
                <a onClick={() => this.handleDepartmentClick(department)}>
                  <div className="thumb">
                    <img src={menuDepKeys[department.dep].icon} alt="" />
                  </div>
                  <div className="content">
                    <h2>{department.dep}</h2>
                    <p>{menuDepKeys[department.dep].label}</p>
                  </div>
                  <div className="thumb right">
                    <img src={ChevronIcon} alt="" />
                  </div>
                </a>
              </li>
            ) : null;
          })}
        </ul>
        {promoImage && promoImage.PromoMobileImage && (
          <div>
            {promoImage && promoImage.ProductIdMobile.length > 0 ? (
            <div className="col-md-12 col-lg-7 featured-image-container banner-container">
            <img src={promoImage.PromoMobileImage[0]} className="image"  alt="Promotional Items banner"/>
            <div class="middle">
            <div className="list-group">
            <span className='promotional-item-text pb-2'>PROMOTIONAL PRODUCTS :</span>
            <ul>
            {
              this.props.promoImage.ProductIdMobile.map((productid, i) => {
              let currentUrl = `products/${productid._id}`;                 
              return (<li key={i} className="promotional-item-text pl-2"><Link to={currentUrl} >{productid.Description}</Link></li>) 
            })}</ul>
            </div>
            </div>
            </div>
            ) : (
              null
            )}
          </div>
        )}
      </div>
    );
  }

  renderMobileCategories() {
    let { currentDepartment } = this.state;
    const { departments } = this.props;
    currentDepartment = departments.find(department => {
      return department.dep == currentDepartment;
    });

    return (
      <div className="main-nav-mobile">
        <ul className="list">
          {currentDepartment && (
            <li>
              <Link
                className="category"
                to={`/products?department=${encodeURIComponent(
                  currentDepartment.dep
                )}`}
              >
                <div className="content">
                  <h2 className="category-heading">
                    ALL {currentDepartment.dep}
                  </h2>
                </div>
                <div className="thumb right">
                  <img src={ChevronIcon} alt="" />
                </div>
              </Link>
            </li>
          )}

          {currentDepartment &&
            currentDepartment.cat.map(category => {
              return (
                <li key={category}>
                  <Link
                    className="category"
                    to={`/products?category=${encodeURIComponent(category)}`}
                  >
                    <div className="content">
                      <h2 className="category-heading">{category}</h2>
                    </div>
                    <div className="thumb right">
                      <img src={ChevronIcon} alt="" />
                    </div>
                  </Link>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }

  render() {
    console.log("HOME_PAGE_PROPS", this.props);
    const { loading, isMobile, promoImage } = this.props;
    const { showAlert, swalParams, openDepartmentMenu } = this.state;
    let featured_WINES = Utils.toJS(this.props.featured_WINES);
    let featured_LIQUOR = Utils.toJS(this.props.featured_LIQUOR);
    let featured_BEER = Utils.toJS(this.props.featured_BEER);
    return (
      <div className="page homepage">
        <div className={`slider-container ${isMobile ? "mobile" : ""}`}>
          <MainSlider />
        </div>
        {!isMobile ? (
          <div>
            <div className="featured-products-container">
              <div className="container">
                <div className="row">
                {featured_WINES ? (
                      <FeaturedList
                        title="WINE"
                        icon={WineIcon}
                        products={featured_WINES}
                        viewAllLinkProps={{
                          to: "/products?department=WINES"
                        }}
                        onSelectProduct={this.onSelectFeaturedProduct}
                        onProductAddToCart={this.addToCart}
                        onCheckAvailiblityAlert={() => this.checkAvailiblityAlert()}
                      />
                    ) : (
                      <div>Loading</div>
                    )}
                    {featured_LIQUOR ? (
                      <FeaturedList
                        products={featured_LIQUOR}
                        title="LIQUOR"
                        icon={LiquorIcon}
                        viewAllLinkProps={{
                          to: "/products?department=LIQUOR"
                        }}
                        onSelectProduct={this.onSelectFeaturedProduct}
                        onProductAddToCart={this.addToCart}
                        onCheckAvailiblityAlert={() => this.checkAvailiblityAlert()}
                      />
                    ) : (
                      <div>Loading</div>
                    )}
                    {featured_BEER ? (
                      <FeaturedList
                        title="BEER"
                        products={featured_BEER}
                        icon={BeerIcon}
                        viewAllLinkProps={{
                          to: "/products?department=BEER"
                        }}
                        onSelectProduct={this.onSelectFeaturedProduct}
                        onProductAddToCart={this.addToCart}
                        onCheckAvailiblityAlert={() => this.checkAvailiblityAlert()}
                      />
                    ) : (
                      <div>Loading</div>
                    )}
                </div>
              </div>
            </div>
            {/* <div className="ads-container">
                            <a className="current-ad" href="https://jasonsliquor.com/products/5a2a87ef66bca850e6a9f4bb">
                                &nbsp;
                            </a>
                        </div> */}
            {promoImage ? (
              <div className="special-offers-container pt-0">
                <div className="container">
                  <SpecialOffers />
                </div>
              </div>
            ) : null}

            <div className="featured-products-container">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 col-sm-12 product-cards">
                    <NavLink to="/products/newarrivals" className="title-link">
                      <h2 className="row-title">New Arrivals</h2>
                    </NavLink>
                    {this.renderProducts("newArrivals")}
                  </div>
                  <div className="col-md-6 col-sm-12 product-cards">
                    <NavLink to="/products/specials" className="title-link">
                      <h2 className="row-title">SPECIALS</h2>
                    </NavLink>
                    {this.renderProducts("specials")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {!openDepartmentMenu
              ? this.renderMobileDepartments()
              : this.renderMobileCategories()}
          </div>
        )}
        <Loader visibility={loading} />
        <SweetAlert
          customClass={"with-close"}
          showCancelButton
          cancelButtonText={"x"}
          onCancel={() => this.setState({ showAlert: false })}
          show={showAlert}
          {...swalParams}
        />
      </div>
    );
  }

  onSelectFeaturedProduct(product) {
    this.props.history.push(`/products/${product._id}`);
  }

  doAgeValidation(successCallback, errorCallback) {
    const { isAgeValid } = this.state;
    let validAge = LocalStorage.get("valid_age");
    if (validAge && validAge === "yes") {
      return this.setState({ isAgeValid: true });
    }

    let swalParams = Swal.getAgeValidationParams(
      () => {
        LocalStorage.put("valid_age", "yes");
        this.setState({
          showAlert: false,
          isAgeValid: true,
          swalParams: swalParams
        });
      },
      () => {
        swalParams.text = `<div className="error-message">You must have to 21 years or above to use website!</div>`;
        LocalStorage.put("valid_age", "no");
        this.setState({
          showAlert: true,
          isAgeValid: false,
          swalParams: swalParams
        });
      }
    );
    this.setState({ showAlert: true, swalParams: swalParams });
  }

  handleError(response) {
    console.log("error", response);
    if (!response.status) {
      this.setState({
        showAlert: true,
        swalParams: {
          title: "Something went wrong!",
          type: "error",
          showConfirmButton: false,
          customClass: "with-close",
          showCancelButton: true,
          cancelButtonText: "x",
          onCancel: this._onCancel
        }
      });
      // setTimeout(() => this.setState({showAlert: false}), 2000);
    }
  }
  _onCancel() {
    this.setState({ showAlert: false });
  }

  addToCart(product) {
    Utils.addToCart(product)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false
          }
        });
        setTimeout(() => this.setState({ showAlert: false }), 1500);
      })
      .catch(err => {
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
        setTimeout(() => this.setState({ showAlert: false }), 2500);
      });
  } 
  checkAvailiblityAlert() {
   
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Address not selected",
            type: "error",
            showConfirmButton: false
          }
        });
        
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 992
});

export default withSizes(mapSizesToProps)(
  connect(state => {
    return {
      newArrivals: state.getIn(["products", "newArrivals"]),
      //bestSellers: state.getIn(['products', 'bestSellers']),
      specials: state.getIn(["products", "specials"]),
      featured_WINES: state.getIn(["products", "featured_WINES"]),
      featured_LIQUOR: state.getIn(["products", "featured_LIQUOR"]),
      featured_BEER: state.getIn(["products", "featured_BEER"]),
      loading:
        state.getIn(["products", "loading"]) ||
        state.getIn(["users", "loading"]),
      departments: state.getIn(["products", "departments"]) || [],
      promoImage: state.getIn(["users", "promoImage"])
    };
  })(HomePage)
);



// WEBPACK FOOTER //
// ./src/containers/home/HomePage.js